// Ported from frontend/src/lib/analytics.ts (types stripped).
const POSTHOG_KEY = 'phc_paE89WgjH9fZRQgmhpxUqNXt4i2fRKQ2VbPDhcKoDpqb';

function isProductionHost() {
  const host = window.location.hostname;
  return host === 'gettingaway.co.uk' || host === 'www.gettingaway.co.uk';
}

export function initAnalytics() {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args) {
    window.dataLayer.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', 'G-58YQM2KP4F');

  if (!window.posthog) return;

  window.posthog.init(POSTHOG_KEY, {
    api_host: isProductionHost()
      ? 'https://i.imagineanythingcolouring.com'
      : 'https://eu.i.posthog.com',
    ui_host: 'https://eu.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false,
  });
}

export function trackPageView(pathname, title) {
  if (typeof window === 'undefined') return;
  if (typeof window.posthog?.capture !== 'function') return;
  window.posthog.capture('$pageview', {
    current_url: window.location.href,
    pathname,
    search: window.location.search,
    page_title: title,
    canonical_url:
      document.querySelector('link[rel="canonical"]')?.getAttribute('href') ||
      window.location.href,
    referrer: document.referrer || null,
  });
}
